// TODO: Should be replaced in future with better i18n approach
export const formatTimezoneIdToName = (timezone: string) => timezone.replace(/_/g, ' ');
